import { scrollToElement as _scrollToElement } from '@phoenix/helpers/common-helper';

export function scrollToElement(element, behavior = 'smooth', addCheckoutSectionHeaderOffset = true) {
  let offset = document.querySelector('nav.navbar').getBoundingClientRect().height;

  if (addCheckoutSectionHeaderOffset) {
    offset += document.querySelector('header.checkout-section__header')?.getBoundingClientRect().height ?? 0;
  }

  _scrollToElement(element, behavior, offset);
}
